module.exports = __webpack_public_path__ + "img/harmonyOS_bg7.0fc659e9.jpg";